export default __webpack_public_path__ + "static/media/amarin-tv.98b3de5b.jpg";